import React from "react"
import { FormattedMessage } from "react-intl"
import { Container, Row, Col, Nav } from "react-bootstrap"

import StoryblokImage from "../../internal/storyblokImage/StoryblokImage"
import LanguageSelector from "../languageSelector/LanguageSelector"
import SiteSocialLinks from "../siteSocialLinks/SiteSocialLinks"
import RioLog from "../../../../static/images/rt_2022_primary_red_rgb.svg"
import useSiteSettings from "../../../hooks/useSiteSettings"



const LandingFooter = ({ navigation, lang, isLanding = false }) => {
  const settings = useSiteSettings(lang)
  
  const {
    copywrite,
    footer_title,
    terms_conditions,
    privacy_policy,
    language_selector,
    logo,
  } = settings || {};

  return (
    <footer className="footer footer-landing">
      <Container>
        <Row className="footer-container">
          <Col className="footer-logo footer-landing-col">
          {/* <Col xl="2"> */}
            <span >
              <StoryblokImage sbImageData={logo} />
            </span>
          </Col>
          <Col xl="2" lg="6" md="12" className="footer-lang-column footer-landing-col">
            <div className="footer-lang">
              {/* <LanguageSelector language_selector={language_selector} lang={lang} withStyle={{margin: "auto 0px"}} /> */}
              <SiteSocialLinks settings={settings}/>
            </div>
          </Col>
        </Row> 
        <Row>
          <Col xl="6" lg="6" md="12">
            <p>Copyright © {new Date().getFullYear()}. {copywrite}</p>
          </Col>
          <Col xl="5" lg="5" md="6" sm="12" className="terms-and-policy-col">
            <Nav className="justify-content-end terms-and-policy">
              <Nav.Item>
                <Nav.Link
                  href={
                    terms_conditions && terms_conditions.url
                      ? terms_conditions.url
                      : ""
                  }
                >
                  <FormattedMessage id="component.global.footer.terms_conditions" />
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link
                  href={
                    privacy_policy && privacy_policy.url
                      ? privacy_policy.url
                      : ""
                  }
                >
                  <FormattedMessage id="component.global.footer.privacy_policy" />
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </Col>
          <Col xl="1" lg="1" md="6" sm="12" className="justify-content-end rio-logo">
            <img
              src={RioLog}
              alt="Rio Tinto"
              width="80px"
              height="30px"
              style={{ maxWidth: "80px" }}
            />
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default LandingFooter;
